<script setup lang="ts">
import { CapacityTextStatus } from '@itinerary/trip/types';

interface IProps {
    capacityText: string;
    capacityStatus: CapacityTextStatus;
}
const { capacityStatus } = defineProps<IProps>();

const color = computed(() =>
    capacityStatus === CapacityTextStatus.low
        ? 'var(--red-400)'
        : 'var(--cool-gray-800)'
);
</script>

<template>
    <mr-typography class="capacity-text" weight="500" :color>
        {{ capacityText }}
    </mr-typography>
</template>

<style lang="scss" scoped>
.capacity-text {
    flex: 1;
    &.desktop-only {
        flex: unset;
        margin-right: auto !important;
        flex-shrink: 0 !important;
    }
}
</style>
